var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipse = function SvgEllipse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.924 1.043c7.346-4.351 19.135 6.48 28.11 3.992 8.977-2.488 14.985-.637 20.58 9.302 4.558 8.1-2.975 7.982 3.982 25.747 6.957 17.765-4.912 18.907-16.383 18.907-13.962.542-20.797 1.006-30.209 1.006-9.412 0-13.857.439-19.2-9.055-4.48-7.957-14.84-15.811-4.073-25.297 10.766-9.487 7.907-19.103 17.192-24.602Z",
    fill: "#FCEFEE"
  })));
};
export default SvgEllipse;